import { useCallback } from 'react';

import useEnum from '@hooks/useEnum';

import ProcessoService from '@services/ProcessoService';

const useOrigemProblema = () => {
    const fetch = useCallback(() => ProcessoService.listarOrigensDosProblemasDeNome(), []);
    const { data, loading, error } = useEnum(fetch);

    return { data, loading, error };
}

export default useOrigemProblema;